import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from "../../../elements/field-error/field-error";

// construccion del objecto yup de validacion del cuestionario
let obligado = {
    name: Yup.string().required('obligatorio')
};
const validacion = Yup.object().shape(obligado);

const initialValues = {
    name: ''
};

export const MarcasForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {

    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);


    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);

        if (enviaremos.id) {
            
            // update
            api(`/fleet/car-brands/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create
            api('/fleet/car-brands/', 'POST', enviaremos);
        }
    };

    useEffect(() => {
  
        if (state.data) {
            if (state.path.includes('brands')) {
                close();
            }
        }

        if (state.error) {
            if (state.error.name && state.error.name[0] === "Ya existe brand con este name.") {
                toast.error(`${t('common.label.error.name')}`);
            }else{
                toast.error('Server Error');
            }
        }
    }, [state]);

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={data || initialValues}
                validationSchema={validacion}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="flex">
                            <div className="w-full">
                                <div className="my-[11px] w-full">
                                    {/* --------------------NAME------------------- */}
                                    <Input
                                        name="name"
                                        label={t('common.form-label.name')}
                                        type="text"
                                        placeholder={t('common.form-label.name')}
                                        value={values.name}
                                        onChange={(value) =>
                                            setFieldValue('name', value.name)
                                        }
                                    />
                                    <FieldError touched={touched} errors={errors} field={"name"} />
                                    {/* --------------------NAME------------------- */}

                                </div>

                            </div>
                        </div>

                        <FormFooter
                            item={item}
                            doDelete={doDelete}
                            doSubmit={handleSubmit}
                            close={close}
                        />
                    </form>
                )}
            </Formik>
        </div>
    );
};